<div class="custom-tab-wrapper my-4">
  <div class="custom-tab-buttons">
    <button [ngClass]="{ active: selectedTab === 0 }" (click)="selectedTab = 0">
      Unprocessed
    </button>
    <button [ngClass]="{ active: selectedTab === 1 }" (click)="selectedTab = 1">
      Processed
    </button>
  </div>

  <div class="custom-tab-content">
    <ng-container [ngSwitch]="selectedTab">
      <app-missing-shares-unprocessed
        *ngSwitchCase="0"
      ></app-missing-shares-unprocessed>
      <app-missing-shares-processed
        *ngSwitchCase="1"
      ></app-missing-shares-processed>
    </ng-container>
  </div>
</div>
